import type { LinkedinSourceValue } from '../types';

export const linkedinExcludeFiltersKeys: {
  [K in keyof LinkedinSourceValue]?: string;
} = {
  showReposts: 'repost'
};
